import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaDatosPersonales from "../vistas/vista_datos_personales";
import FormDatosPersonales from "../formularios/form_datos_personales";

export default class DesplegableDatosPersonales extends Component {
  render() {
    return (
      <Desplegable
        eventKey="0"
        id="0"
        Toogle="Datos Personales"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalMatrix[0]}
        Text={<VistaDatosPersonales DatosUsuario={this.props.state.DatosUsuario}></VistaDatosPersonales>}
        Form={
          <FormDatosPersonales
            DatosUsuario={this.props.state.DatosUsuario}
            setDatosPersonales={this.props.setDatosPersonales}
            handleButtonShow={this.props.handleButtonShow}
            nullField={this.props.nullField}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormDatosPersonales>
        }
        canEdit={true}
      />
    );
  }
}
